import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { AddLearnerOfflineActivity, AddLearnerOfflineActivityError, AddLearnerOfflineActivitySuccess, EditLearnerOfflineActivity, EditLearnerOfflineActivityError, EditLearnerOfflineActivitySuccess, GetOfflineActivity, GetOfflineActivityError, GetOfflineActivitySkillSelection, GetOfflineActivitySkillSelectionError, GetOfflineActivitySkillSelectionSuccess, GetOfflineActivitySuccess, SetOfflineActivityNavigationRoute, StoreOfflineActivityNavigationSession } from "./learner-offline-activity.actions";
import { catchError, map, switchMap } from "rxjs/operators";
import { AddLearnerOfflineActivityDto, EditLearnerOfflineActivityDto, LearnerLearningRecord } from "src/app/_models/LearnerLearningRecord";
import { HttpErrorResponse } from "@angular/common/http";
import { of } from "rxjs";
import { LearnerOfflineActivityService } from "src/app/_services/learner-offline-activity.service";

@Injectable()
export class LearnerOfflineActivityEffects {
  constructor(
    private action$: Actions,
    private learnerOfflineActivityServices: LearnerOfflineActivityService
  ) {}

  public addLearnerOfflineActivityEffect$ = createEffect(() => 
    this.action$.pipe(
      ofType(AddLearnerOfflineActivity),
      switchMap((payload) => 
        this.learnerOfflineActivityServices.createLearnerOfflineActivity$(payload.addOfflineActivity).pipe(
          map((result: AddLearnerOfflineActivityDto) => {
            return AddLearnerOfflineActivitySuccess({ result: result });
          }),
          catchError((error: HttpErrorResponse) => {
            return of(AddLearnerOfflineActivityError({ error: error }));
          }),
        )
      )
    )
  );

  public editLearnerOfflineActivityEffect$ = createEffect(() =>
    this.action$.pipe(
      ofType(EditLearnerOfflineActivity),
      switchMap((payload) => 
        this.learnerOfflineActivityServices.updateLearnerOfflineActivity$(payload.editOfflineActivity).pipe(
          map((result: EditLearnerOfflineActivityDto) => {
            return EditLearnerOfflineActivitySuccess({ result: result });
          }),
          catchError((error: HttpErrorResponse) => {
            return of(EditLearnerOfflineActivityError({ error: error }));
          })
        )
      ),
    )
  );

  public getOfflineActivitySkillSelectionEffect$ = createEffect(() =>
    this.action$.pipe(
      ofType(GetOfflineActivitySkillSelection),
      switchMap((payload) => 
        this.learnerOfflineActivityServices.getOfflineActivitySkill$(payload.courseId).pipe(
          map((result: string[]) => {
            return GetOfflineActivitySkillSelectionSuccess({ result: result });
          }),
          catchError((error: HttpErrorResponse) => {
            return of(GetOfflineActivitySkillSelectionError({ error: error }));
          })
        )
      ),
    )
  );

  public getOfflineActivityEffect$ = createEffect(() =>
    this.action$.pipe(
      ofType(GetOfflineActivity),
      switchMap((payload) => 
        this.learnerOfflineActivityServices.getOfflineActivity$(payload.scormEntryId).pipe(
          map((result: LearnerLearningRecord) => {
            return GetOfflineActivitySuccess({ result: result });
          }),
          catchError((error: HttpErrorResponse) => {
            return of(GetOfflineActivityError({ error: error }));
          })
        )
      ),
    )
  );

  public setOfflineActivityNavigationRouteEffect$ = createEffect(() =>
    this.action$.pipe(
      ofType(SetOfflineActivityNavigationRoute),
      map(() => {
        return StoreOfflineActivityNavigationSession();
      })
    )
  );
}